"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeaturedList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all featured objects.
 *
 * ### Filter options
 *
 * - `type` - filter by type of the featured object,
 * - `memberId` - filter by ID of the member who posted it,
 * - `gameId` - filter by ID of the linked game,
 * - `gameTitle` - filter by title of the linked game,
 * - `from` - filter by being newer than a specified date,
 * - `to` - filter by being older than a specified date.
 *
 * ### Sort options
 *
 * - `date` - sorts by date of posting.
 *
 * ## Usage
 *
 * ```ts
 * const featuredAll: Featured[] = await sdk.getFeaturedList({ });
 * const featuredVideos: Featured[] = await sdk.getFeaturedList({ filter: { type: FeaturedType.VIDEO }});
 * const featuredLastWeek: Featured[] =
 * 	await sdk.getFeaturedList({ sort: { from: 2019-07-07T16:38:19.000+00:00 }});
 * ```
 *
 * @param params.filter - Filter to apply to returned featured list.
 * @param params.sort - Fields to sort featured list by.
 * @param params.limit - How many featured objects will get returned.
 */
const getFeaturedList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/featured/list`;
    const featuredResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = featuredResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getFeaturedList = getFeaturedList;
